module.exports = __webpack_public_path__ + "files/c839726261f36138ab85e07ff5d48e52.png";